import * as ng from 'angular';
import * as moment from 'moment';

ng.module('e360')
   .filter('timeOfDay', () => timeOfDayFilter);

export function timeOfDayFilter(value?:number):string {
   if (!value) {
      return '';
   }

   let hours = Math.floor(value / 60);
   let minutes = value % 60;
   let closeTime = moment();

   closeTime.hours(hours);
   closeTime.minutes(minutes);

   return closeTime.format('h:mma');
}
